import { render } from "./MessagePush.vue?vue&type=template&id=4e88e1d6&scoped=true"
import script from "./MessagePush.vue?vue&type=script&lang=js"
export * from "./MessagePush.vue?vue&type=script&lang=js"

import "./MessagePush.vue?vue&type=style&index=0&id=4e88e1d6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e88e1d6"]])

export default __exports__